// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"1":"479e27f4","145":"71431b9f","387":"75f47c74","390":"b2669e89","848":"ec712c74","861":"2aa2164f","875":"c8b72126"}[chunkId] + ".chunk.js";
};